<template>
  <div class="prepare-layout">
    <template v-if="bundle.prepared">
      <slot v-bind="bundle"></slot>
    </template>
    <template v-else>
      <slot name="prepare"
            v-bind="bundle">
        <div class="loading">
          <div v-if="typeof bundle.percentage === 'number'"
               class="progress">
            <el-progress text-inside
                         :stroke-width="14"
                         :percentage="bundle.percentage"></el-progress>
          </div>
          <div class="text">
            <i class="el-icon-loading"></i>
            <span>{{bundle.statusText || prepareWord}}</span>
          </div>
        </div>
      </slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PrepareLayout',
  props: {
    prepareUrl: {
      type: String,
      required: true
    },
    prepareParams: Object,
    prepareWord: {
      type: String,
      default: '数据准备中，请稍等...'
    },
    prepareCallback: {
      type: Function,
      default: (data, bundle) => {
        Object.keys(bundle).forEach(key => {
          bundle[key] = data[key]
        })
      }
    },
    prepareActive: {
      type: Boolean,
      default: true
    },
    autoStart: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      bundle: {
        prepared: false,
        percentage: undefined,
        statusText: '',
        result: null
      },
      timeout: 1000
    }
  },
  methods: {
    checkPrepare () {
      if (!this.prepareActive) {
        return
      }
      if (this.bundle.prepared) {
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.$ajax({
        url: this.prepareUrl,
        method: 'post',
        data: this.$qs.stringify(this.$extend(this.prepareParams))
      }).then(response => {
        if (response.data) {
          this.prepareCallback(response.data, this.bundle)
          this.$nextTick(() => {
            if (!this.bundle.prepared) {
              this.timer = setTimeout(() => this.checkPrepare(), this.timeout)
            } else {
              this.$emit('prepared', this.bundle)
            }
          })
        }
      }).catch(() => {
        this.timer = setTimeout(() => this.checkPrepare(), this.timeout)
      })
    },
    prepare () {
      this.bundle.prepared = false
      this.bundle.percentage = undefined
      this.bundle.statusText = ''
      this.bundle.result = null
      this.$nextTick(() => {
        this.checkPrepare()
      })
    }
  },
  mounted () {
    if (this.autoStart) {
      this.prepare()
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  watch: {
    prepareActive (val) {
      if (val) {
        this.checkPrepare()
      }
    }
  }
}
</script>

<style lang="scss">
  .prepare-layout {
    position: relative;
    height: 100%;
    background-color: #fff;
    & > .loading {
      position: absolute;
      left: 50%;
      top: 50%;
      max-width: 100%;
      transform: translate(-50%,-50%);
      margin-top: -1px;
      & > .progress {
        margin-bottom: 8px;
        width: 260px;
        .el-progress {
          .el-progress-bar {
            .el-progress-bar__outer {
              .el-progress-bar__inner {
                .el-progress-bar__innerText {
                  vertical-align: 0;
                  transform: scale(.8);
                }
              }
            }
          }
        }
      }
      & > .text {
        font-size: 12px;
        font-weight: bold;
        i {
          margin-right: 2px;
          color: #303133;
          font-size: 15px;
          vertical-align: -1px;
        }
      }
    }
  }
</style>
